<template lang='slm'>
.hello
  bz-view v-bind:articleIds='articleIds'

</template>

<script>
import BzView from '@/components/BzView'

export default {
  name: 'hello',
  data () {
    return {
      articleIds: ['title', 'top', 'bottom']
    }
  },
  components: { BzView }
}
</script>

<style scoped lang='scss'>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.hello {
  margin-top: 60px;
}

</style>



// WEBPACK FOOTER //
// src/components/Hello.vue